<template>
  <div class="mb-8">
    <div class="flex items-center">
      <p class="text-dark-blue">
        {{ subject }}
      </p>
      <slot />
    </div>
    <p class="mb-4 text-xxs font-bold uppercase text-gray-over-dark">
      {{ question.description }}
    </p>
    <input
      v-model="answer"
      class="integer-or-float w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
      :placeholder="question.is_type === 'input_integer' ? '7' : '7.50'"
      :onkeypress="question.is_type === 'input_integer' ? isInteger : isFloat"
      @input="handleInput"
    />
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['child-check'],
  data() {
    return {
      answer: '',
    };
  },
  computed: {
    stepName() {
      return this.$store.state.formRoutes?.activeStepIdentifier;
    },
  },
  // created() {
  //   let recentAnswer = this.question?.most_recent_previous_answer;
  //   if (recentAnswer) {
  //     this.answer = (this.question?.is_type === 'input_integer') ? recentAnswer?.integer_value : recentAnswer?.float_value;
  //     this.handleAutoInput();
  //   }
  // },
  watch: {
    stepName: {
      handler(newVal) {
        if (newVal == 'Questions') {
          let recentAnswer = this.question?.most_recent_previous_answer;
          if (recentAnswer) {
            this.answer =
              this.question?.is_type === 'input_integer'
                ? recentAnswer?.integer_value
                : recentAnswer?.float_value;
            this.handleAutoInput();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleInput(e) {
      let type =
        this.question.is_type === 'input_integer'
          ? 'integer_value'
          : 'float_value';
      let body = {
        company_question_id: this.question_id,
        [type]: e.target.value,
      };
      this.setOnboardingPacket(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(e.target.value);
    },
    handleAutoInput() {
      let type =
        this.question.is_type === 'input_integer'
          ? 'integer_value'
          : 'float_value';
      let body = null;
      if (this.answer) {
        body = {
          company_question_id: this.question_id,
          [type]: this.answer,
        };
      }
      this.setOnboardingPacket(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.answer);
    },
    isInteger(e) {
      let charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
      return true;
    },
    isFloat(e) {
      let charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && charCode != 46 && (charCode < 48 || charCode > 57))
        return false;
      return true;
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (
            child?.evaluation_js?.length > 0 &&
            child?.company_question_id > 0
          ) {
            this.$emit(
              'child-check',
              child.company_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
    },
  },
};
</script>
